import React from 'react';
import './TitleLabel.scoped.scss';

interface Props {
  children?: React.ReactNode;
  title?: string;
}

const TitleLabel: React.FC<Props> = ({ children }) => {
  return <label className="text-bold mt-1 flex title">{children}</label>;
};

export default TitleLabel;
